import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'
import { Box, LinearProgress, SelectChangeEvent } from '@mui/material'
import styled from '@emotion/styled'
import SingleSelect from '../../../../components/muiComponents/singleSelect'
import { Body1, H3 } from '../../../../layouts/TextStyles'
import { videonotesApiSlice } from '../../../../features/section/videonotesSlice'
import TopicVideonotesCard from '../components/TopicVideonotesCard'

interface Props {
    subjectId: number | null
    userCourseEnrollId: number
    loadingSubjects?: boolean
}

const VideonotesTab: React.FC<Props> = ({
    subjectId,
    loadingSubjects = false,
    userCourseEnrollId
}) => {
    const { formatMessage } = useIntl()
    const [searchParams] = useSearchParams()
    const [courseSubject, setCourseSubject] = useState(Number(searchParams.get('courseSubjectId')) || null)
    const { data: videonotes = [], isFetching } =
        videonotesApiSlice.useGetStudentTopicVideonotesAnalysisQuery(
            { courseSubjectId: courseSubject, userCourseEnrollId: userCourseEnrollId },
            { skip: !courseSubject },
        )

    useEffect(() => {
        if (subjectId) {
            setCourseSubject(subjectId)
        }
    }, [subjectId])

    return (
        <Box>
            {isFetching ? (
                <LinearProgress />
            ) : (
                videonotes.length > 0 ? videonotes.map((videonotes) => (
                    <TopicVideonotesCard
                        key={videonotes.id}
                        videonotes={videonotes}
                    />
                )) :
                    <Body1 color="#434343" style={{ textAlign: 'center' }}>{formatMessage({ id: 'noVideonotes' })}</Body1>
            )}



        </Box>
    )
}

export default VideonotesTab

